export class CompanySetting {
    tableName: string;
    tablePkid: number;
    serviceType: string;
    oocls_company_pkid: number;
    oocls_company_id: string;
    oocls_location_pkid: number;
    oocls_location_timezone_id: number;
    oocls_company_symbol_position: string;
    oocls_company_name: string
    oocls_banner_image_name: string;
    oomls_promotional_message: string
    oomls_slider_promotional_message: string
    oomls_slider_promotional_message1: string
    ools_location_latlang: string
    table_qr: boolean;
    store_qr: boolean;
    store_qr_dinein: boolean;
    store_qr_takeaway: boolean;
    oocls_location_address: string;
    oocls_location_name: string;
    oocls_order_open: boolean;

    company_logo: string;

    qrType: number; // 1 => TABLE QR, 2 => LOCATION QR, 3 => COMPANY
    constructor(data: Partial<CompanySetting>) {
        Object.assign(this, data);

    }
}